<div class="commentaries" body>
  <div class="commentaries-title">
    {{ "COMPONENTS.COMMENTS" | translate }}
  </div>
  <div
    class="commentaries-list-wrapper"
    *ngIf="commentaries?.length && isShowList"
  >
    <div class="commentaries-list" *ngFor="let commentary of commentaries">
      <app-comentaries-item [commentary]="commentary"></app-comentaries-item>
    </div>
  </div>
  <div
    *ngIf="!commentaries?.length && isShowList"
    class="commentaries-list-wrapper"
  >
    {{ "DIALOG.TITLE.NO_COMMENTS" | translate }}
  </div>
  <div class="commentaries-new" *ngIf="isShowCreateComment">
    <textarea
      id="commentaries"
      class="commentaries-input"
      [placeholder]="'FORM.PLACEHOLDER.COMMENT' | translate"
      [value]="newComment"
      (input)="onValueChange($event)"
      rows="2"
    ></textarea>
    <button
      mat-icon-button
      (click)="handleNewComment()"
      [disabled]="!newComment.length"
    >
      <svg-icon [name]="'send-comment'"></svg-icon>
    </button>
  </div>
</div>
